exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".-botpress-channel-web__style__input___3yaCn {\n  outline: none; }\n  .-botpress-channel-web__style__input___3yaCn textarea {\n    font: inherit;\n    background-color: transparent;\n    min-height: 32px;\n    max-height: 96px;\n    margin-bottom: 0;\n    font-size: 14px;\n    padding: 8px;\n    width: 100%;\n    border: none;\n    resize: none;\n    line-height: 1.2; }\n", ""]);

// exports
exports.locals = {
	"input": "-botpress-channel-web__style__input___3yaCn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"@botpress/channel-web__[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/views/web/input/style.scss
// module id = 172
// module chunks = 0